export const MAX_VALID_FILE_SIZE = 104_857_600; // 100MB
export const invalidFileMessage = "Invalid File";
export const invalidFileSizeMessage = "Uploaded file size should be less than 100MB";
